export { default as NewArticleBody } from "./NewArticleBody";
